import styled, { css } from 'styled-components';
import { darken, lighten } from 'polished';

import { device } from 'styles/device';

export const CheckLabel = styled.label`
  flex-shrink: 1;
  margin: 0 0 0 0;
`;
export const Container = styled.div`
  min-height: 38px; /*era 50px*/
  margin-bottom: 10px;
`;

export const Content = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: ${props =>
    props.columns ? props.columns : '1fr 1fr 1fr'};
  @media ${device.laptop} {
    grid-template-columns: ${props =>
      props.columns ? props.columns : '1fr 1fr'};
  }

  @media ${device.mobileM} {
    grid-template-columns: 1fr;
  }

  ${props =>
    props.direction === 'column' &&
    css`
      grid-template-columns: 1fr;
    `}

  text-transform: uppercase;
  label {
    margin-right: 15px;
    input {
      position: absolute;
      left: -9999px;

      &:checked + ${CheckLabel}, &:not(:checked) + ${CheckLabel} {
        position: relative;
        padding: 0 0 0 23px;
        cursor: pointer;
        line-height: 20px;
        display: flex;
      }

      &:checked + ${CheckLabel} {
        color: ${props => props.theme.checkbox.selected};
      }

      &:not(:checked) + ${CheckLabel} {
        color: ${props => props.theme.checkbox.notselected};
      }

      &:checked
        + ${CheckLabel}::before,&:not(:checked)
        + ${CheckLabel}::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 20px;
        height: 20px;

        border-radius: 100%;
        ${props =>
          props.theme.name === 'dark'
            ? css`
                background: ${lighten(0.06, props.theme.cardBackgroud)};
                border: 1px solid ${props.theme.componentborder};
              `
            : css`
                background: ${darken(0.05, props.theme.cardBackgroud)};
                border: 1px solid ${props.theme.componentborder};
              `}

        ${props =>
          props.$error === 'true' &&
          css`
            border: 1px solid ${props => props.theme.error};
          `}
      }

      &:checked + ${CheckLabel}::after, &:not(:checked) + ${CheckLabel}::after {
        content: '';
        width: 10px;
        height: 10px;
        background: ${props => props.theme.checkbox.selected};
        position: absolute;
        top: 5px;
        left: 5px;
        border-radius: 100%;
        -webkit-transition: all 0.2s ease;
        transition: all 0.2s ease;
      }

      &:not(:checked) + ${CheckLabel}::after {
        opacity: 0;
        -webkit-transform: scale(0);
        transform: scale(0);
      }
      &:checked + ${CheckLabel}::after {
        opacity: 1;
        -webkit-transform: scale(1);
        transform: scale(1);
      }

      &:disabled + ${CheckLabel} {
        cursor: not-allowed;
        opacity: 0.6;
      }
    }
  }
`;

export const ErrorMessage = styled.span`
  margin-top: 1.5px;
  align-self: flex-start;
  display: flex;
  flex: 1 1;
  flex-wrap: wrap;
  font-size: 0.75rem;
  color: ${props => props.theme.error};
`;
